import { Loader, Select } from "@mantine/core"
import React from "react"
import { useActions, useAppState } from "src/state"
import { Tenant_Status_Enum, Tenant_Type_Enum } from "src/state/gql/_types"
import { GenericFieldProps } from "src/utils/forms"
import { capitalizeWords } from "src/utils/string"

export const SuperAdminVenueSelect: React.FC<GenericFieldProps> = ({ id, name, label, onChange, onBlur, value, error, required, description, disabled, classNames }) => {

    const { itemsList, loading } = useAppState(state => state.tenants)
    const  getAllItems = useActions().tenants.getAllItems

    React.useEffect(() => {

        let controller: AbortController | null = new AbortController();

        const loadItems = async () => {

            if (controller) {
                try {
                    await getAllItems({
                        where: { 
                            status: {
                                _eq: Tenant_Status_Enum.Active
                            },
                            type: {
                                _neq: Tenant_Type_Enum.Agency
                            }
                        }
                    })
                    controller = null;
                } catch (e: any) {
                    if (e.name !== 'AbortError') {
                        console.error(e)
                    }
                }
            }

        }
        
        loadItems()

        return () => controller?.abort()

    }, [])

    if (!!!itemsList.length) error = 'No Active Venues'
    
    return (
        <Select
            label={label}
            id={id}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            error={error}
            required={required}
            disabled={disabled}
            description={description}
            rightSection={loading ? <Loader size="xs" /> : null}
            placeholder="Select Venue..."
            searchable
            clearable
            data={itemsList.map(i=>({
                label: capitalizeWords(`${i.name}`),
                value: i.id
            }))}
            autoComplete="off"
            classNames={classNames}
        />
    )

}
